import api, { unwrap } from './client';
import type { ApiResponse } from '@/types/api';

export interface PlatformConfig {
  general: {
    frontendUrl: string;
    frontendUrlFromDb: boolean;
    corsOrigins: string;
    corsOriginsFromDb: boolean;
  };
  mail: {
    from: string;
    fromName: string;
    host: string;
    port: number;
    username: string;
    passwordConfigured: boolean;
    smtpReady: boolean;
  };
  sso: {
    enabled: boolean;
    callbackBaseUrl: string;
    google: { enabled: boolean; clientId: string; clientSecretConfigured: boolean };
    microsoft: { enabled: boolean; clientId: string; clientSecretConfigured: boolean };
  };
  security: { mfaIssuer: string };
  rateLimit: {
    enabled: boolean;
    maxRequestsPerMinute: number;
    authMaxRequestsPerMinute: number;
  };
}

export type PlatformConfigUpdate = Partial<{
  frontendUrl: string;
  corsOrigins: string;
  mfaIssuer: string;
  ssoEnabled: boolean;
  ssoCallbackBaseUrl: string;
  ssoGoogleEnabled: boolean;
  ssoGoogleClientId: string;
  ssoGoogleClientSecret: string;
  ssoMicrosoftEnabled: boolean;
  ssoMicrosoftClientId: string;
  ssoMicrosoftClientSecret: string;
  mailFrom: string;
  mailFromName: string;
  mailHost: string;
  mailPort: number;
  mailUsername: string;
  mailPassword: string;
  rateLimitEnabled: boolean;
  rateLimitMax: number;
  rateLimitAuthMax: number;
}>;

export const platformConfigApi = {
  get: () => unwrap(api.get<ApiResponse<PlatformConfig>>('/v1/master/platform-config')),
  save: (body: PlatformConfigUpdate) =>
    unwrap(api.put<ApiResponse<PlatformConfig>>('/v1/master/platform-config', body)),
};
